import { FC, type JSX, useMemo } from 'react';
import { GoogleAutocomplete } from '@/editor/components/googleMaps/GoogleAutocomplete';
import { MapContainer } from '@/editor/components/googleMaps/MapContainer';
import { LocationChips } from '@/editor/components/googleMaps/LocationChips';
import { useJsApiLoader, Libraries } from '@react-google-maps/api';

export interface ICircleViewModel {
  address: string;
  circle: google.maps.Circle;
}

export const ConfiguredGoogleMap: FC = (): JSX.Element => {
  const libraries = useMemo(() => ['places'], []);
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyC-MgcSme2UDlU0hZeEoBN97nqvlV83yx4',
    libraries: libraries as Libraries,
  });

  return (
    <>
      {isLoaded && (
        <>
          <GoogleAutocomplete></GoogleAutocomplete>
          <LocationChips></LocationChips>
          <MapContainer></MapContainer>
        </>
      )}
    </>
  );
};
